export let suggestionsLoading = "nGGQHc";
export default {suggestionsLoading};